export default __webpack_public_path__ + "static/media/owlpostmagic.ca7a31b2.jpg";